// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"875791a3","49":"46508c1a","130":"804724c7","181":"22a37829","258":"a212d379","475":"8c491bd7","533":"3039ef60","560":"3bde1861","612":"332af7a9","641":"473933ec","833":"0d20afc2","869":"15072873"}[chunkId] + ".chunk.js";
};